import React, {useState} from 'react';
import { styled } from "styled-components";
import ArrowImage from '~/assets/arrow.png';
import DeleteIconImage from "~/assets/delete.png";

const Wrapper = styled.div`
`;

const HeaderForSubItem = styled.div`
  border-top: 1px solid #E0E0E0;
  padding-top: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  
  img {
    float: right;
  }
  
  .deleteItem {
    float: unset;
    position: absolute;
    margin-top: -3px;
    margin-left: 10px;
    cursor: pointer;
  }

  .open {
    transform: rotateX(190deg);
  }
`;

const SubItem = ({ children, length, itemKey, duplicatable, onDelete, disabledDeleteBtn }) => {
  const [showElements, setShowElements] = useState((length == 1 || itemKey == 1) ? true : false);

  const deleteItem = (e) => {
    e.stopPropagation();
    if (onDelete && !disabledDeleteBtn) {
      onDelete();
    }
  };

  return (
    <Wrapper>
      {length > 1 && (
        <HeaderForSubItem onClick={() => setShowElements(!showElements)}>
          <strong>
            Element {itemKey}
            {duplicatable && <img className='deleteItem' src={DeleteIconImage} alt='Delete' onClick={deleteItem} />}
          </strong>
          <img src={ArrowImage} alt='Arrow' className={showElements ? 'open' : ''} />
        </HeaderForSubItem>
      )}
      {showElements && children}
    </Wrapper>
  );
};

export default SubItem;
